import { CholesterolUnit, UnitSystem } from "./Settings";

export enum Units {
  Nanograms = "nanograms",
  Miligrams = "miligrams",
  Grams = "grams",
}

export function ComputeBMI(weight: number, height: number, unit: UnitSystem): number {

  if (height > 0) {
    return unit === UnitSystem.Metric ? weight / (height * height / 10000) : weight * 0.45359237 / (height * height * 0.0254 * 0.0254);
  }
  else
    return 0;
}

export function GetBMI(weight: number, height: number, unit: UnitSystem): string {
  return unit === UnitSystem.Metric ? `${Math.floor(weight / height / height * 10000)} kg/m2`
    : `${Math.floor(Math.floor(weight * 703 / height / height))} lbs X 703/inches2`;
}

export function FormatHeight(height:number, unit:UnitSystem) : string {
  return unit === UnitSystem.Metric
    ? `${height} cm`
    : `${Math.floor(height / 12)} ft ${height % 12} in`;
}

export function GetCholesterolStr(value: number, unit: CholesterolUnit): string {
  return unit === CholesterolUnit.mgdl ? `${value} mg/dl` : `${value.toFixed(1)} mmol/l`;
}

export function GetWeightValues(unit: UnitSystem): [number, number, string] {
  switch (unit) {
    case UnitSystem.Imperial:
      return [100, 500, 'lb']
    case UnitSystem.Metric:
    default:
      return [50, 230, 'kg'];
  }
}

export function GetHeightValues(unit: UnitSystem): [number, number, string] {
  switch (unit) {
    case UnitSystem.Imperial: 
      return [48, 96, 'ft-in'];
    case UnitSystem.Metric:
    default:
      return [140, 230, 'cm'];
  }
}

export function GetCholesterolValues(unit: CholesterolUnit): [number, number, string] {

  switch (unit) {
    case CholesterolUnit.mmol:
      return [3.5, 7.7, 'mmol/L'];
    case CholesterolUnit.mgdl:
    default:
      return [140, 300, 'mg/dl'];
  }
}